
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en-gb/products/balance",
      function () {
        return require("private-next-pages/en-gb/products/balance.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en-gb/products/balance"])
      });
    }
  